import { useState } from 'react';
import { Link } from 'react-router-dom';

const CATEGORIES = [
  {
    icon: 'bi-person-plus',
    color: '#e8f0fe',
    iconColor: '#4285F4',
    title: 'Compte & inscription',
    desc: 'Créer un compte, vérification, mot de passe',
    articles: [
      { label: 'Comment créer un compte ?', to: '/signup' },
      { label: 'Mot de passe oublié', to: '/forgot-password' },
      { label: 'Vérification de votre identité', to: '/rental-conditions' },
      { label: 'Modifier vos informations personnelles', to: '/guest/settings' },
    ],
  },
  {
    icon: 'bi-search',
    color: '#fff3e0',
    iconColor: '#ff6600',
    title: 'Trouver & réserver',
    desc: 'Recherche, disponibilités, demande de réservation',
    articles: [
      { label: 'Comment rechercher un véhicule ?', to: '/comment-ca-marche' },
      { label: 'Comment faire une demande de réservation ?', to: '/comment-ca-marche' },
      { label: 'Comprendre les états de réservation', to: '/etats-reservation' },
      { label: 'Conditions conducteur (âge, permis)', to: '/rental-conditions' },
    ],
  },
  {
    icon: 'bi-credit-card',
    color: '#e6f4ea',
    iconColor: '#34A853',
    title: 'Paiement & garantie',
    desc: 'Tarifs, commission, dépôt de garantie, remboursements',
    articles: [
      { label: 'Comment fonctionne le paiement ?', to: '/regles-business#commission' },
      { label: 'Commission plateforme', to: '/regles-business#commission' },
      { label: 'Dépôt de garantie — montant et libération', to: '/regles-business#garantie' },
      { label: "Politique d'annulation et remboursements", to: '/regles-business#annulation' },
    ],
  },
  {
    icon: 'bi-key',
    color: '#f3e8ff',
    iconColor: '#9c27b0',
    title: 'Propriétaire / Hôte',
    desc: 'Mettre sa voiture en location, revenus, check-in',
    articles: [
      { label: 'Comment louer ma voiture ?', to: '/location-voiture' },
      { label: 'Parcours complet propriétaire', to: '/comment-ca-marche' },
      { label: 'Gérer mes disponibilités', to: '/account/voitures' },
      { label: 'Recevoir mes paiements (Stripe Connect)', to: '/guest/settings' },
    ],
  },
  {
    icon: 'bi-speedometer2',
    color: '#fce4ec',
    iconColor: '#e91e63',
    title: 'Kilométrage & carburant',
    desc: 'Forfaits km, surcharges, carburant',
    articles: [
      { label: 'Comment fonctionne le kilométrage inclus ?', to: '/regles-business#kilometrage' },
      { label: 'Tarif des km supplémentaires', to: '/regles-business#kilometrage' },
      { label: 'Règle carburant au retour', to: '/regles-business#kilometrage' },
    ],
  },
  {
    icon: 'bi-shield-check',
    color: '#e0f7fa',
    iconColor: '#00acc1',
    title: 'Assurance & litiges',
    desc: 'Couverture AXA, dommages, signalement',
    articles: [
      { label: "Couverture d'assurance incluse", to: '/rental-conditions' },
      { label: 'Que faire en cas de dommage ?', to: '/etats-reservation' },
      { label: 'Ouvrir un litige', to: '/etats-reservation' },
      { label: 'Délai de résolution des litiges', to: '/regles-business#garantie' },
    ],
  },
];

const FAQS = [
  {
    q: 'Puis-je annuler ma réservation sans frais ?',
    a: 'Oui, si vous annulez plus de 7 jours avant le début de la location, vous êtes remboursé à 100 %. Entre 48 h et 7 jours, le remboursement est de 50 %. Moins de 48 h avant, aucun remboursement.',
  },
  {
    q: 'Comment est calculé le dépôt de garantie ?',
    a: "Le montant dépend de la catégorie du véhicule : 300 € (Éco), 600 € (Confort), 1 200 € (Privilège), 2 500 € (Prestige). C'est une pré-autorisation sur votre carte, libérée sous 72 h après le checkout sans incident.",
  },
  {
    q: 'Que se passe-t-il si je dépasse le kilométrage inclus ?',
    a: 'Les kilomètres supplémentaires sont facturés à 0,13 €/km par défaut. Le montant est prélevé automatiquement sur votre carte lors de la validation du checkout par le propriétaire.',
  },
  {
    q: 'Comment recevoir mes paiements en tant que propriétaire ?',
    a: "Vous devez compléter l'onboarding Stripe Connect depuis vos paramètres de compte. Le virement est initié automatiquement 24 h après la validation du checkout, déduction faite de la commission de 15 %.",
  },
  {
    q: 'Quels documents sont obligatoires pour louer ?',
    a: "Permis de conduire original (uploadé + présenté au check-in) et pièce d'identité. Les copies ou attestations temporaires ne sont pas acceptées. Pour certaines catégories, une vérification de profil est exigée.",
  },
  {
    q: "Comment fonctionne l'assurance ?",
    a: "Tous les trajets sont couverts par AXA pendant la durée de la location. La couverture est active dès la validation du check-in jusqu'à la validation du checkout par le propriétaire.",
  },
];

export default function HelpPage() {
  const [search, setSearch] = useState('');
  const [openFaq, setOpenFaq] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);

  const filteredFaqs = FAQS.filter(
    (f) =>
      !search ||
      f.q.toLowerCase().includes(search.toLowerCase()) ||
      f.a.toLowerCase().includes(search.toLowerCase())
  );

  const filteredCats = CATEGORIES.filter(
    (c) =>
      !search ||
      c.title.toLowerCase().includes(search.toLowerCase()) ||
      c.desc.toLowerCase().includes(search.toLowerCase()) ||
      c.articles.some((a) => a.label.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="bg-body-tertiary min-vh-100">
      {/* ── Hero ── */}
      <div
        className="py-5 text-white text-center"
        style={{ background: 'linear-gradient(135deg, #ff6600 0%, #ff9a3c 100%)' }}
      >
        <div className="container" style={{ maxWidth: 680 }}>
          <h1 className="fw-bold mb-2" style={{ fontSize: 'clamp(24px, 5vw, 38px)' }}>
            Comment pouvons-nous vous aider ?
          </h1>
          <p className="mb-4 opacity-75" style={{ fontSize: 16 }}>
            Centre d'aide Moovicar — trouvez des réponses à toutes vos questions.
          </p>

          {/* Barre de recherche */}
          <div className="position-relative" style={{ maxWidth: 520, margin: '0 auto' }}>
            <i
              className="bi bi-search position-absolute top-50 translate-middle-y text-muted"
              style={{ left: 16, zIndex: 2, fontSize: 16 }}
            ></i>
            <input
              type="search"
              className="form-control rounded-pill py-3 ps-5 pe-4 shadow-sm border-0"
              placeholder="Rechercher une question, un sujet…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ fontSize: 15 }}
            />
          </div>
        </div>
      </div>

      <div className="container py-5" style={{ maxWidth: 1040 }}>
        {/* ── Liens rapides ── */}
        {!search && (
          <div className="row g-3 mb-5">
            {[
              {
                icon: 'bi-map',
                label: 'Comment ça marche',
                to: '/comment-ca-marche',
                color: '#ff6600',
              },
              {
                icon: 'bi-percent',
                label: 'Règles business',
                to: '/regles-business',
                color: '#4285F4',
              },
              {
                icon: 'bi-diagram-3',
                label: 'États de réservation',
                to: '/etats-reservation',
                color: '#34A853',
              },
              {
                icon: 'bi-file-earmark',
                label: 'Conditions de location',
                to: '/rental-conditions',
                color: '#9c27b0',
              },
            ].map(({ icon, label, to, color }) => (
              <div key={to} className="col-6 col-md-3">
                <Link
                  to={to}
                  className="card border-0 shadow-sm rounded-4 p-3 text-center text-decoration-none text-body h-100 d-flex flex-column align-items-center justify-content-center gap-2"
                  style={{ transition: 'transform .15s, box-shadow .15s' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = '';
                    e.currentTarget.style.boxShadow = '';
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{ width: 48, height: 48, background: color + '18' }}
                  >
                    <i className={`bi ${icon}`} style={{ fontSize: 22, color }}></i>
                  </div>
                  <span className="fw-semibold" style={{ fontSize: 13 }}>
                    {label}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        )}

        {/* ── Catégories ── */}
        <h5 className="fw-bold mb-3">
          {search ? `Résultats pour "${search}"` : 'Parcourir par catégorie'}
        </h5>

        <div className="row g-3 mb-5">
          {filteredCats.map((cat) => {
            const isOpen = activeCategory === cat.title;
            return (
              <div key={cat.title} className="col-12 col-md-6">
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                  <button
                    className="btn text-start w-100 p-3 d-flex align-items-center gap-3 border-0"
                    style={{ background: 'white' }}
                    onClick={() => setActiveCategory(isOpen ? null : cat.title)}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                      style={{ width: 44, height: 44, background: cat.color }}
                    >
                      <i
                        className={`bi ${cat.icon}`}
                        style={{ fontSize: 20, color: cat.iconColor }}
                      ></i>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="fw-semibold mb-0 text-truncate" style={{ fontSize: 14 }}>
                        {cat.title}
                      </p>
                      <p className="text-muted mb-0 text-truncate" style={{ fontSize: 12 }}>
                        {cat.desc}
                      </p>
                    </div>
                    <i
                      className={`bi bi-chevron-${isOpen ? 'up' : 'down'} text-muted flex-shrink-0`}
                      style={{ fontSize: 13 }}
                    ></i>
                  </button>

                  {isOpen && (
                    <div className="border-top">
                      {cat.articles.map((a) => (
                        <Link
                          key={a.label}
                          to={a.to}
                          className="d-flex align-items-center gap-2 px-4 py-2 text-decoration-none text-body border-bottom"
                          style={{ fontSize: 13 }}
                        >
                          <i
                            className="bi bi-arrow-right text-primary flex-shrink-0"
                            style={{ fontSize: 11 }}
                          ></i>
                          {a.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {filteredCats.length === 0 && (
            <div className="col-12 text-center py-4 text-muted">
              <i className="bi bi-search" style={{ fontSize: 32 }}></i>
              <p className="mt-2">Aucune catégorie ne correspond à votre recherche.</p>
            </div>
          )}
        </div>

        {/* ── FAQ ── */}
        <h5 className="fw-bold mb-3">Questions fréquentes</h5>
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-5">
          {filteredFaqs.map((faq, i) => {
            const isOpen = openFaq === i;
            return (
              <div key={i} className={i < filteredFaqs.length - 1 ? 'border-bottom' : ''}>
                <button
                  className="btn text-start w-100 px-4 py-3 d-flex align-items-center justify-content-between gap-3 border-0 bg-white"
                  onClick={() => setOpenFaq(isOpen ? null : i)}
                >
                  <span className="fw-semibold" style={{ fontSize: 14 }}>
                    {faq.q}
                  </span>
                  <i
                    className={`bi bi-chevron-${isOpen ? 'up' : 'down'} text-muted flex-shrink-0`}
                    style={{ fontSize: 13 }}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-4 pb-3 text-muted" style={{ fontSize: 13, lineHeight: 1.7 }}>
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}

          {filteredFaqs.length === 0 && search && (
            <div className="text-center py-4 text-muted" style={{ fontSize: 14 }}>
              Aucune FAQ ne correspond à votre recherche.
            </div>
          )}
        </div>

        {/* ── Contact ── */}
        <div
          className="rounded-4 p-4 p-md-5 text-center"
          style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d4e 100%)', color: '#ccc' }}
        >
          <i className="bi bi-headset text-white mb-3" style={{ fontSize: 36 }}></i>
          <h5 className="fw-bold text-white mb-1">Vous n'avez pas trouvé de réponse ?</h5>
          <p className="mb-4" style={{ fontSize: 14 }}>
            Notre équipe est disponible pour vous aider du lundi au vendredi, 9 h – 18 h.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-3">
            <a
              href="mailto:support@moovicar.com"
              className="btn btn-light rounded-pill px-4 fw-semibold"
              style={{ fontSize: 14 }}
            >
              <i className="bi bi-envelope me-2"></i>support@moovicar.com
            </a>
            <Link
              to="/inbox/messages"
              className="btn btn-outline-light rounded-pill px-4 fw-semibold"
              style={{ fontSize: 14 }}
            >
              <i className="bi bi-chat-dots me-2"></i>Messagerie
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
